function Stats() {
    return (
      <div className="stats">
        <div className="stats_container">
          <div className="stats-1">
            <div>300+</div>
            <p>Affilates</p>
          </div>
          <div className="stats-1">
            <div>5K+</div>
            <p>Apps Inventory</p>
          </div>
          <div className="stats-1">
            <div >1M+</div>
            <p>App Installs</p>
          </div>
          <div className="stats-1">
            <div>3K+</div>
            <p>Active Campaigns</p>
          </div>
        </div>
      </div>
    );
  }
  export default Stats;